const BRAND_LOGO = "/images/logos/brandborn.png";

const PlatformLogosShowcase = () => {
  const allLogos = [
    { name: "Myntra", logo: "/images/logos/myntra.jpeg" },
    { name: "Blinkit", logo: "/images/logos/blinkit.jpeg" },
    { name: "BigBasket", logo: "/images/logos/bigbasket.jpeg" },
    { name: "Swiggy", logo: "/images/logos/swiggy.jpeg" },
    { name: "JioMart", logo: "/images/logos/jiomart.jpeg" },
    { name: "Nykaa", logo: "/images/logos/nykaa.png" },
    { name: "Ajio", logo: "/images/logos/ajio.png" },
    { name: "Amazon", logo: "/images/logos/amazon.png" },
    { name: "Flipkart", logo: "https://static-assets-web.flixcart.com/batman-returns/batman-returns/p/images/fkheaderlogo_exploreplus-44005d.svg" },
    { name: "Tata CLiQ", logo: "/images/logos/tata-cliq.png" },
    { name: "Purplle", logo: "/images/logos/purplle.png" },
    { name: "Meesho", logo: "/images/logos/meesho.svg" },
  ];

  // Split into 2 rows for marquee
  const row1 = allLogos.slice(0, 6);
  const row2 = allLogos.slice(6, 12);

  const LogoCard = ({ platform }) => (
    <div className="flex-shrink-0 mx-3 group" data-testid={`brand-logo-${platform.name.toLowerCase().replace(/\s/g, '-')}`}>
      <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center p-1 shadow-lg border border-gray-100 transition-all duration-300 group-hover:scale-110 group-hover:shadow-xl group-hover:border-red-300 overflow-hidden">
        <img
          src={platform.logo}
          alt={platform.name}
          className="w-full h-full object-contain rounded-lg"
          loading="lazy"
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'flex';
          }}
        />
        <span className="text-black font-black text-[10px] hidden items-center justify-center">{platform.name.substring(0,3)}</span>
      </div>
      <p className="text-center text-gray-400 text-[10px] font-semibold mt-1.5 tracking-wide">{platform.name}</p>
    </div>
  );

  return (
    <section className="py-10 md:py-14 bg-white overflow-hidden" data-testid="platform-logos-showcase">
      <div className="max-w-5xl mx-auto px-4">
        {/* Header */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 mb-8">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 bg-red-50 border border-red-100 rounded-lg mb-2">
              <span className="text-[10px] tracking-[0.2em] uppercase font-bold text-red-500">70+ Partners</span>
            </div>
            <h3 className="text-2xl md:text-3xl font-black text-black">
              We Launch Brands On
            </h3>
          </div>
          <p className="text-sm text-gray-400">
            <span className="text-red-500 font-bold">1000+</span> brands launched
          </p>
        </div>

        {/* Row 1 - scrolls left */}
        <div className="relative mb-4">
          <div className="marquee-row-left flex">
            {[...row1, ...row1, ...row1].map((p, i) => (
              <LogoCard key={`r1-${i}`} platform={p} />
            ))}
          </div>
        </div>

        {/* Center - BrandBorn logo */}
        <div className="flex items-center justify-center my-4">
          <div className="flex items-center gap-4">
            <div className="h-px w-16 md:w-32 bg-gradient-to-r from-transparent to-gray-200" />
            <div className="w-14 h-14 rounded-2xl bg-white flex items-center justify-center shadow-lg border-2 border-black overflow-hidden p-1">
              <img src={BRAND_LOGO} alt="BrandBorn" className="w-full h-full object-contain" />
            </div>
            <div className="h-px w-16 md:w-32 bg-gradient-to-l from-transparent to-gray-200" />
          </div>
        </div>

        {/* Row 2 - scrolls right */}
        <div className="relative mt-4">
          <div className="marquee-row-right flex">
            {[...row2, ...row2, ...row2].map((p, i) => (
              <LogoCard key={`r2-${i}`} platform={p} />
            ))}
          </div>
        </div>

        {/* Bottom text */}
        <p className="text-center text-gray-300 text-xs mt-6">
          + Nykaa Fashion, Ajio Luxe, Aza Fashions, Zepto, FirstCry & 60 more
        </p>
      </div>

      <style jsx>{`
        @keyframes scrollLeft {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.33%); }
        }
        @keyframes scrollRight {
          0% { transform: translateX(-33.33%); }
          100% { transform: translateX(0); }
        }
        .marquee-row-left {
          animation: scrollLeft 20s linear infinite;
          width: max-content;
        }
        .marquee-row-right {
          animation: scrollRight 25s linear infinite;
          width: max-content;
        }
        .marquee-row-left:hover,
        .marquee-row-right:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default PlatformLogosShowcase;
